if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(target);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue(target) {
        if (!target) return;

        const { value, dataset, tagName, type } = target;
        const fieldset = target.closest('fieldset[data-swatch-type], div[data-swatch-type]');
        if (!fieldset) return;

        const swatchType = fieldset.dataset.swatchType;
        const selectedValueEl = fieldset.querySelector('[data-selected-swatch-value]');

        // ---- Variant Image Swatches ----
        if (swatchType === 'variant_image' && tagName === 'INPUT' && type === 'radio') {
          if (selectedValueEl) selectedValueEl.textContent = value;
        }

        // ---- Color Swatches ----
        if (swatchType === 'color') {
          // fallback to value if dataset.optionSwatchValue is missing
          const swatchValue = dataset.optionSwatchValue || value;

          if (selectedValueEl) selectedValueEl.textContent = value;

          // update visual swatch circle
          const swatchCircle = fieldset.querySelector(
            '.swatch-color, .swatch, input[type="radio"]'
          );
          if (swatchCircle) {
            // FIX: match CSS variable name
            swatchCircle.style.setProperty('--swatch-background', swatchValue);
            swatchCircle.classList.remove('swatch--unavailable');
            swatchCircle.style.setProperty(
              '--swatch-focal-point',
              dataset.optionSwatchFocalPoint || 'unset'
            );
          }
        }

        // ---- Dropdown Swatches ----
        if (tagName === 'SELECT' && selectedValueEl) {
          selectedValueEl.textContent = value;
        }
      }
    }
  );
}
